var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 2.0999C15.4 1.3999 14.9 0.899903 14.2 0.699903C13 0.399903 7.89999 0.399902 7.89999 0.399902C7.89999 0.399902 2.90001 0.399903 1.60001 0.699903C0.900006 0.899903 0.399997 1.3999 0.199997 2.0999C-3.05474e-06 3.3999 0 5.9999 0 5.9999C0 5.9999 3.03984e-06 8.5999 0.300003 9.8999C0.500003 10.5999 0.999997 11.0999 1.7 11.2999C2.9 11.5999 8 11.5999 8 11.5999C8 11.5999 13 11.5999 14.3 11.2999C15 11.0999 15.5 10.5999 15.7 9.8999C16 8.5999 16 5.9999 16 5.9999C16 5.9999 16 3.3999 15.6 2.0999ZM6.39999 8.3999V3.5999L10.6 5.9999L6.39999 8.3999Z",
    fill: "#0E0005"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.4a919c6f34821a0ca1e4a6f5760adc55.svg";
export { ForwardRef as ReactComponent };